"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpPostBySlug = void 0;
/**
 * Queries for a help post by it's `slug`
 *
 * @param {string} slug - The slug of the page
 * @returns {object} Contentful query
 */
// eslint-disable-next-line import/prefer-default-export
var helpPostBySlug = function helpPostBySlug(_ref) {
  var slug = _ref.slug;
  return {
    content_type: 'helpPost',
    'fields.slug': slug
  };
};
exports.helpPostBySlug = helpPostBySlug;